import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenValid } from '../../utils/jwt-helper';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const isLoggedIn = isTokenValid();

  if (!isLoggedIn) {
    // Redirect to login page with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
